import {SectionId} from './Sections';

export const CUSTOM_SECTIONS_ID = ['HISTORY_CHECK', 'SIMILAR_CARS'] as const satisfies SectionId[];

export type CustomSectionId = (typeof CUSTOM_SECTIONS_ID)[number];
